import React from 'react';
import { object } from 'prop-types';
import { createMarkup } from '../../utils/utils';

const propTypes = {
  page: object.isRequired,
};

const defaultProps = {
  page: {},
};

const FaqContent = ({ page }) => (
  <div>
    <h3>{page.title}</h3>
    <div dangerouslySetInnerHTML={createMarkup(page.page)} />
  </div>
);

FaqContent.propTypes = propTypes;
FaqContent.defaultProps = defaultProps;

export default FaqContent;
